export default {"src":"/_next/static/media/icon_notification_bell.04cd3e2b.svg","height":170,"width":129,"blurWidth":0,"blurHeight":0};